module.exports = "https://coursera_assets.s3.amazonaws.com/images/ab19cc6cf2451485f4096db4ed5485c3.svg";